/**
 * View As lives in this tab's sessionStorage and is sent as `X-View-As` on every API call. Starting
 * or leaving it reloads the page, so no cached answer for one person is ever shown as another's,
 * and closing the tab ends it.
 */
export interface ViewingAs {
  id: string
  displayName: string
  email: string
  photoUrl: string | null
}

const KEY = 'tapwork:view-as'

export function getViewAs(): ViewingAs | null {
  try {
    const raw = window.sessionStorage.getItem(KEY)
    if (!raw) return null
    const value = JSON.parse(raw) as Partial<ViewingAs>
    return value && typeof value.id === 'string' ? (value as ViewingAs) : null
  } catch {
    return null
  }
}

export function setViewAs(person: ViewingAs | null): void {
  try {
    if (person) window.sessionStorage.setItem(KEY, JSON.stringify(person))
    else window.sessionStorage.removeItem(KEY)
  } catch {
    // Storage optional: without it View As simply does not start.
  }
}
